import React, { Fragment, useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";

import {
  InputCopy,
  FormGroup,
  Pill,
  Breadcrumbs,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Table,
  Input,
  ContentBlock,
  RadioGroup,
  ModalAlert,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";
import PAtabs from './PAtabs';
import PAh2 from './PAh2';




import {
  PAconnectorGTM,
  PAconnectorGA,
  PAconnectorFB,
  PAconnectorPN,
  PAconnectorTW
} from "./PAconnectors";

import merge from "deepmerge";
import { ContextConsumer, GlobalContext } from './PA';
import { IntlProvider } from "react-intl";
import PAContentBlock from "./PAContentBlock";
import { Link } from "react-router-dom";
import { CardTodo, CardSite } from "./PAcardNew";

import {
  // PAchart1,
  PAchart2
  // PAchartMap
} from "./PAchart2";


import PAsbSettings from './sitebuilder/PAsbSettings';

const rowsArray = [
  {
    id: 0,
    project: {
      name: "Status"
    },
    amount: 10,
    revenue: 20,
    systemFees: 30,
    tax: 40,
    repatriation: 50,
    balanceFees: 60,
    commission: 70
  },
  {
    id: 1,
    project: {
      name: "Test Project"
    },
    amount: 10,
    revenue: 20,
    systemFees: 30,
    tax: 40,
    repatriation: 50,
    balanceFees: 60,
    commission: 70
  },
  {
    id: 2,
    project: {
      name: "Test Project"
    },
    amount: 10,
    revenue: 20,
    systemFees: 30,
    tax: 40,
    repatriation: 50,
    balanceFees: 60,
    commission: 70
  },
  {
    id: 3,
    project: {
      name: "Test Project"
    },
    amount: 10,
    revenue: 20,
    systemFees: 30,
    tax: 40,
    repatriation: 50,
    balanceFees: 60,
    commission: 70
  }
];



export default function PAsbProjectP({
  product = 'site_builder',
  sku = 'login_1',
  name = "My Game: Ultimate Edition",
  id = "mygame.xsollasitebuilder.com",
  img = "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
  status = "active",
  customize = 'widget',
  button = ()=>{return <Link to="/site_builder/my_project">
    <Button
      appearance="outline"
    >
      Edit settings
    </Button>
  </Link>},
  used = [
    {
      product: 'game_store',
      name: "Game keys / My Game: Ultimate Edition",
      action: "/game_keys/my_project",
      status: 'active',
    },
    {
      product:  'login',
      name: "My Game Login",
      action: "/login/my_project/",
      status: 'draft',
    },
    {
      product: 'launcher',
      name: "My Game Launcher",
      action: "/launcher/my_project/",
      status: 'draft',
    }
  ],
  todo = [
    {
      title: "Complete setting up your landing page",
      value: 0.5
    },
    {
      title: "Sign Licensing Agreement",
      value: 0
    },
    {
      title: "Publish your landing page",
      value: 0
    },
    {
      title: "Set up your own domain",
      value: 0
    },
    {
      title: "Use Partner Network",
      value: 0
    }
  ],
}) {
  const sbVersions = [
    {
      type: 'Version before restore',
      when: "Yesterday",
      date: "06/27/19, 02:37 AM",
      who: "m.miroshnikov@xsolla.com",
      restore: "001"
    },
    {
      type: 'Published',
      when: "1 day ago",
      date: "06/27/19, 02:37 AM",
      who: "a.kozhevnikov@xsolla.com",
      restore: "002"
    },
    {
      type: 'Published',
      when: "2 day ago",
      date: "06/22/19, 02:37 AM",
      who: "m.miroshnikov@xsolla.com",
      restore: "003"
    },
    {
      type: 'Published',
      when: "2 day ago",
      date: "06/23/19, 02:37 AM",
      who: "m.miroshnikov@xsolla.com",
      restore: "004"
    }
  ];

  const columns = [
    // {
    //   id: "type",
    //   name: "Type",
    //   minWidth: 100,
    //   fieldGetter: row => {
    //     return <CssSvnH>{row["type"]}</CssSvnH>;
    //   }
    // },
    {
      id: "date2",
      name: "Date and time",
      // minWidth: '40%',
      fieldGetter: row => {
        return row["date"];
      }
    },
    {
      id: "who",
      name: "Published by",
      // minWidth: '40%',
      fieldGetter: row => {
        return (
          <div
            style={{
              color: "#a0abb8"
            }}
          >
            {row["who"]}
          </div>
        );
      }
    },
    {
      id: "actions",
      name: "",
      // minWidth: '20%',
      fieldGetter: row => {
        return (
          <CssRestoreTD
            style={{
              justifyContent: "flex-end"
            }}
          >
            <span style={{ marginRight: 16 }}>
              <Button appearance="flatten" size="sm">
                <Icon name="new-tab" />
                Preview
              </Button>
            </span>
            <span style={{}}>
              <Button appearance="outline" size="sm">
                <Icon name="redo" />
                Restore
              </Button>
            </span>
          </CssRestoreTD>
        );
      }
    }
  ];

  const renderRow = ({ className, rowIndex, columns, row, CellComponent }) => {
    return (
      <Fragment key={`row-${rowIndex}-1`}>
        <tr className={className} style={{ position: "relative" }}>
          {columns.map((column, columnIdx) => (
            <CellComponent
              key={`row-${row.id || rowIndex}-${column.id}`}
              row={row}
              column={column}
              rowIndex={rowIndex}
              columnIndex={columnIdx}
            />
          ))}
        </tr>
      </Fragment>
    );
  };

  let [state, setState] = useState({
    twoCols: true,
    tab: "settings", //stats,settings,svn

  });

  let globalContext = useContext(GlobalContext);

  useEffect(() => {
    console.log(
      "globalContext.globalState.version = ",
      globalContext.globalState.version
    );
  });

  return (




<div className="xsui-width">



<FormGroup indentation="xs">
      <Breadcrumbs
          //.xsui-breadcrumbs_label {max-width: 100% !important;} //TODO: fix
          items={[
            {
              label: "Site Builder",
              to: "/site_builder"
            },
            {
              label: (
                <React.Fragment>
                  <div className="l_flex">
                    {name}{" "}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <span style={{ margin: "0px 0 0 16px" }}>
                        <Pill
                          appearance={`${
                            status !== "draft" ? `active` : `warning`
                          } `}
                        >
                          <StatusDot
                            status={`${
                              status !== "draft" ? `enabled` : `testing`
                            } `}
                          >
                            {" "}
                            {status}
                          </StatusDot>
                        </Pill>
                      </span>
                    </div>
                  </div>
                </React.Fragment>
              ),
              to: "/site_builder"
            }
          ]}
        />

</FormGroup>




<FormGroup indentation="xlg">
              <PAtabs
                // extra={<Button size="sm" appearance="secondary">Go to Store Builder</Button>}
                active={state.tab}
                handleTab={nw => {
                  // let url = hist.match.location
                  setState({
                    ...state,
                    tab: nw
                  });
                }}
                items={[
                  {
                    name: "Analytics",
                    stateName: "stats",
                    icon: "analytics"
                  },
                  // {
                  //   name: <span>Users and customers&nbsp;&nbsp;<Pill appearance = 'active'>
                  //   {/* <StatusDot
                  //   status="enabled"
                  //   ></StatusDot> */}
                  //   +8
                  //   </Pill></span>,
                  //   stateName: "users",
                  //   icon: "profile"
                  // },

                  {
                    name: "Settings",
                    stateName: "settings",
                    icon: "tile-view"
                  },
                  {
                    name: 'Version history',
                    stateName: 'svn',
                    icon: "redo"
                  },
                  // {
                  //   name: "Refund policy",
                  //   stateName: "refund",
                  //   icon: "exclamation-alert"
                  // }
                ]}
              />

        </FormGroup>




        {useContext(GlobalContext).globalState.version === "misha" && (
          <div>
            <CardSite to="/site_builder/my_project" />
          </div>
        )}







          {state.tab === "settings" && (

            <PAsbSettings/>

          )}



          {state.tab === "stats" && (
            <Fragment>
              <FormGroup>
                <FormGroup indentation="lg">
                  <PAchart2 />
                </FormGroup>

                <FormGroup indentation="lg">{/* <PAchartMap /> */}</FormGroup>
              </FormGroup>
            </Fragment>
          )}




          {state.tab === "svn" && (
            <Fragment>


            {state.restorePop && (
              <ModalAlert
                // fetching={state.restorePop}
                title="Restore the older version?"
                // submitAppearance="alert"
                description="The current version will be replaced with the Version of 06/23/19, 02:37 AM"
                submit="Restore"
                discard="Cancel"
                // icon={require('./../_icons/checkmark-in-circle.svg')}
                isOpen={state.restorePop}
                onClose={() => setState({...state, restorePop: false,})}
              />

              // <ModalAlert
              // title="Data may be lost"
              // description="If you change your secret key or Webhook URL. Do you want to proceed?"
              // discard="Discard"
              // submit="Proceed"
              // submitAppearance="alert"
              // confirmationHandler={()=>{void(0)}}
              // confirmationEl={({value, onChange}) => (
              //   <FormGroup centered={true}>
              //     <Checkbox
              //       input={{
              //         value,
              //         onChange: e => onChange(e.target.value !== 'true')
              //       }}
              //       label="Yes, I understand effect"
              //     />
              //   </FormGroup>
              // )}
              // icon={require('./../_icons/alert--red.svg')}
              // isOpen={isConfirmWithCheckboxModalOpen}
              // onClose={() => setState({restorePop: false})}
              // onSubmit={() => console.log('Confirmed!')} // eslint-disable-line
            // />

            )}



            <FormGroup>
              <CssTable>
                <CssTh
                  // className="ui-table__body__row"
                >
                  <CssRestoreTD className="xsui-table-head-cell__text">Message:</CssRestoreTD>
                  <CssRestoreTD className="xsui-table-head-cell__text">Date and time:</CssRestoreTD>
                  <CssRestoreTD className="xsui-table-head-cell__text">Action by:</CssRestoreTD>
                  <CssRestoreTD className="xsui-table-head-cell__text"></CssRestoreTD>
                </CssTh>


              {sbVersions.map(({type, when, date, who, restore}, ind)=>{
              return (

                  <CssTr
                    style={{
                      padding: '12px',
                    }}
                    className="ui-table__body__row"
                  >

                    <CssRestoreTD>
                        <CssSvnH>{type}</CssSvnH>
                    </CssRestoreTD>

                    <CssRestoreTD>
                        <div style={{
                          fontSize: 12,
                          color: 'rgb(116, 126, 138)',
                        }}>
                         {when}, {date}
                        </div>
                    </CssRestoreTD>
                    <CssRestoreTD>
                      {who}
                    </CssRestoreTD>
                    <CssRestoreTD style={{
                      justifyContent: 'flex-end',
                      }}>
                      <span style={{marginRight: 24}}><Button appearance="flatten" size="sm"><Icon name="new-tab"/>Preview</Button></span>
                      <span style={{}}>
                        <Button
                          onClick={()=>{
                            setState({
                              ...state,
                              restorePop: true,
                            })
                          }}
                          appearance="flatten" size="sm"><Icon name="redo"/>Restore</Button>
                      </span>
                    </CssRestoreTD>

                  </CssTr>

              )
            })}
              </CssTable>
            </FormGroup>

              {/* <Table
                // renderRow={renderRow}
                renderEmptyMessage={() => (
                  <div className={"example-table__empty-message"}>
                    <FormGroup>
                      A new restore version is created when the site is
                      published.
                    </FormGroup>
                  </div>
                )}
                columns={columns}
                rows={sbVersions}
              /> */}
            </Fragment>
          )}

          {state.tab === "svn2" && (
            <Fragment>
              <FormGroup>
                <div style={{height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center',}}>
                A new restore version is created when the site is published.
                </div>
              </FormGroup>

            </Fragment>
          )}



      </div>

  );
}

const CssRestoreTD = styled.div`
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  flex-basis: 160px;
  flex-grow: 1;
  flex-shrink: 0;
`;

const CssSvnH = styled.div`
  color: rgb(0, 36, 77);
  font-weight: bold;
  font-size: 15px;
`;

const CssTable = styled.div`
  border: none;
`;
const CssTh = styled.div`
  justify-content: flex-start;
  display: flex;
  padding: 12px;
  border: none;
  border-bottom: 1px solid #c5d0db;
  background-color: transparent;
  font-size: 13px;
  width: 100%;
  color: #747e8a;
`;
const CssTd = styled.div`
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  border: none;
`;
const CssTr = styled.div`
  display: flex;
  padding: 0;
  margin: 0;
  border: 0px solid red !important;
`;

